import React, { useRef, useLayoutEffect, useContext } from 'react';
import { get } from '@libs/shared';
import { authModel } from '../../models';
import { ConfigProviderContext } from '../../contexts';

interface WWOpenDataComProps {
    openId: string;
    children: React.ReactNode;
}

/**
 * 企业微信-ISV密文企业-通讯录展示组件
 */
const WWOpenDataCom: React.FC<WWOpenDataComProps> = (props) => {
    const { openId, children } = props;

    const ref = useRef(null);
    const { h5JsApiReady } = useContext(ConfigProviderContext);

    const ww = get(window, 'ww');
    // 兼容未传 h5JsApiReady 的调用方：仅显式为 false 时按未就绪处理，undefined 时沿用原有判断。
    const showDefaultChildren =
        !authModel.hasISVEncryptedIntegration || !ww || !openId || h5JsApiReady === false;

    useLayoutEffect(() => {
        if (showDefaultChildren) {
            return;
        }
        // ww.initOpenData 成功回调后，WWOpenData 才会注入到 window 对象上面
        if (window.WWOpenData && ref.current) {
            window.WWOpenData.bind(ref.current);
        }
    }, [openId, children, showDefaultChildren]);

    if (showDefaultChildren) {
        return <>{children}</>;
    }

    return React.createElement('ww-open-data', {
        ref,
        type: 'userName',
        openid: openId
    });
};

export default WWOpenDataCom;
